import * as ImagePicker from "expo-image-picker";
import { Alert } from "react-native";

export async function checkAndAlertPhotoGrantedPermission(): Promise<boolean> {
  const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
  if (status !== "granted") {
    Alert.alert(
      "Permission Required",
      "Sorry, we need camera roll permissions to upload images. Please enable permissions in your device settings.",
      [{ text: "OK" }],
    );
    return false;
  } else {
    return true;
  }
}
